import React from "react";
import { useGoogleAnalytics } from "../context/googleAnalytics";
import useMapConfig, { DistanceUnit } from "../utils/useMapConfig";

interface Props {
  className?: string;
}

const DistanceUnitSelector: React.FC<Props> = ({ className }) => {
  const { trackEvent } = useGoogleAnalytics();
  const distanceUnit = useMapConfig((state) => state.distanceUnit);
  const setDistanceUnit = useMapConfig((state) => state.setDistanceUnit);

  return (
    <div className={className}>
      <select
        id="currency"
        className="w-full pl-3 py-2 sm:text-sm rounded-md dark:bg-gray-800"
        onChange={(e) => {
          trackEvent("update distance unit", {
            event_category: "user settings",
            event_label: e.target.value
          });
          setDistanceUnit(e.target.value as DistanceUnit);
        }}
        value={distanceUnit}
      >
        <option key={DistanceUnit.m} value={DistanceUnit.m}>
          Metric (m)
        </option>
        <option key={DistanceUnit.ft} value={DistanceUnit.ft}>
          Imperial (ft)
        </option>
      </select>
    </div>
  );
};

export default DistanceUnitSelector;
